import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UnitService } from '../views/units/services/unit.service';

/**
 * Prevents navigation to routes that require root-unit access.
 * Waits for unit data to be available before deciding.
 * Redirects non-root-unit users to the settings page.
 */
export const canActivateRootUnitGuard: CanActivateFn = () => {
  const unitService = inject(UnitService);
  const router = inject(Router);

  return toObservable(unitService.currentUnit).pipe(
    filter((unit) => unit !== null),
    take(1),
    map((unit) => {
      if (unit.prevUnitId !== null) {
        return router.createUrlTree(['/settings']);
      }
      return true;
    })
  );
};
